export default __webpack_public_path__ + "static/media/slider13.454924ec.jpeg";